import "./CompleteRegistration.scss"
import CompleteRegistrationStepperCard, {
    completeRegistrationStepperCardItems
} from "./completeRegistrationStepperCard/CompleteRegistrationStepperCard";
import {RaikoLabel, RaikoLabelType} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";


export default function CompleteRegistration() {

    const [selectedStep, setSelectedStep] = useState(3)

    return (
        <section className={"completeRegistrationBaseLayout"}>
            <div className={"completeRegistrationBaseStepper"}>
                <RaikoLabel text={"تکمیل فرایند ثبت نام"} raikoLabelType={RaikoLabelType.TITLE}/>
                {
                    completeRegistrationStepperCardItems.map((item, index) => {
                        return <CompleteRegistrationStepperCard
                            index={index}
                            title={item.title}
                            subTitle={item.subTitle}
                            step={item.step}
                            selectedStep={selectedStep}
                            icon={item.icon}
                        />
                    })
                }

            </div>
            <div className={"completeRegistrationBaseContainer"}>
                محتوا
            </div>
        </section>
    )
}